
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { CategoryModel } from "@/models/CategoryModel";
import { getModule } from "vuex-module-decorators";
import FilterModule from "../../store/modules/FilterModule";
import { Helpers } from "@/global-scripts/helpers";

@Component({
  components: {},
})
export default class CategoryList extends Vue {
  private variantFilterModule = getModule(FilterModule, this.$store);

  @Prop()
  data!: CategoryModel[];

  private get categoryData(): CategoryModel[] {
    return this.data || [];
  }

  private onClick(category: CategoryModel) {
    this.$emit("onclick", category);
  }

  private getCategoryPath(category: CategoryModel): string {
    return `${this.variantFilterModule.basePath}/${Helpers.urlFriendlyName(category.title)}`;
  }

  private getFilterClass(category: CategoryModel): string {
    const classList: string[] = [];

    classList.push(Helpers.getFilterClass(category));

    if (this.$validityHelper.catIncludeNews(category, this.variantFilterModule.activeFilters)) {
      classList.push("news");
    }

    return classList.join(" ");
  }
}
